import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/styles/main.css";
import "./assets/styles/fonts.css";
import "./api/axiosInterceptor";

import { getAuth, onAuthStateChanged } from "firebase/auth";
import { AnalyticsService, AnalyticsEvent } from "./utils/AnalyticsService";

const savedTheme = localStorage.getItem("theme");

const systemTheme =
  window.matchMedia &&
  window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";

const theme = savedTheme || systemTheme;

document.documentElement.setAttribute("data-theme", theme);

const auth = getAuth();
let appMounted = false;

onAuthStateChanged(auth, async () => {
  if (!appMounted) {
    const app = createApp(App);
    app.use(router);

    AnalyticsService.log(AnalyticsEvent.INIT_START_APP);

    app.mount("#app");

    appMounted = true;
  }
});